// Cargador ÚNICO del JS SDK de Facebook (0375 / 0386). Compartido por el onboarding OAuth de
// Facebook/Instagram (FacebookOAuthConnect) y el Embedded Signup de WhatsApp (WabaEmbeddedSignup).
// Con timeout (un bloqueador/anti-tracking que traga el <script> nunca dispara onerror) y SIN
// crossOrigin (fuerza modo CORS y algunos navegadores bloquean la ejecución del SDK).
const SDK_SRC = "https://connect.facebook.net/es_LA/sdk.js";

export const loadFacebookSdk = (appId, version) =>
  new Promise((resolve, reject) => {
    if (window.FB) {
      resolve(window.FB);
      return;
    }
    if (!appId) {
      reject(
        new Error(
          "El servidor no devolvió el App ID de Meta. ¿Reiniciaste el backend tras editar el .env?"
        )
      );
      return;
    }
    let settled = false;
    const finishOk = (fb) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve(fb);
    };
    const finishErr = (err) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      reject(err);
    };
    const timer = setTimeout(
      () =>
        finishErr(
          new Error(
            "El SDK de Facebook no cargó (posible bloqueador/anti-tracking del navegador). Desactívalo para localhost y reintenta."
          )
        ),
      10000
    );
    window.fbAsyncInit = function () {
      window.FB.init({ appId, version: version || "v21.0", cookie: true, xfbml: false });
      finishOk(window.FB);
    };
    const existing = document.getElementById("facebook-jssdk");
    if (existing) return; // fbAsyncInit (reasignado arriba) resolverá al terminar de cargar
    const script = document.createElement("script");
    script.id = "facebook-jssdk";
    script.src = SDK_SRC;
    script.async = true;
    script.defer = true;
    script.onerror = () =>
      finishErr(new Error("No se pudo cargar el SDK de Facebook (bloqueado por el navegador o la red)."));
    document.body.appendChild(script);
  });

export default loadFacebookSdk;
